import { useMutation } from "@tanstack/react-query";
import { postPassPromotionalMessage } from "apis";

const usePostPassPromoMsg = () => {
  return useMutation(postPassPromotionalMessage);
};

export default usePostPassPromoMsg;
